"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "cancelPresenterKnock", {
  enumerable: true,
  get: function get() {
    return _cancelPresenterKnock["default"];
  }
});
var _cancelPresenterKnock = _interopRequireDefault(require("./cancelPresenterKnock"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }